import styled from "styled-components";

const InputContainer = styled.div`
    flex-grow: 1;
    margin-right: 1em;
    min-width: 5em;
`;

export default InputContainer;
